/**
 * Tick-based status debouncer: a new raw value must repeat for `minTicks`
 * consecutive ticks before it replaces the committed value. Kills the
 * one-tick flicker that detection signals produce near decision thresholds
 * (banner flashing ready ↔ face-unclear, the box blinking green/amber).
 */
export function createStatusDebouncer<T>(minTicks: number, initial: T): (raw: T) => T {
  let committed = initial;
  let pending = initial;
  let streak = 0;

  return (raw: T): T => {
    if (raw === committed) {
      pending = raw;
      streak = 0;
      return committed;
    }
    if (raw === pending) {
      streak += 1;
    } else {
      pending = raw;
      streak = 1;
    }
    if (streak >= minTicks) {
      committed = raw;
      streak = 0;
    }
    return committed;
  };
}
